// libs
import React from "react";

// defs
import { SEVERITY } from "@defs/Severity";

// components
import { Alert as MuiAlert, AlertProps, AlertTitle } from "@mui/material";

// props
export interface IBannerProps {
    title: string;
    content?: string;
    severity: SEVERITY;
    isDismissible?: boolean;
}

const Banner: React.FC<IBannerProps> = ({ title, severity, content, isDismissible }) => {
    if (isDismissible) return <></>;

    const alertProps: AlertProps = {
        severity: severity,
    };

    return (
        <MuiAlert {...alertProps} sx={{ position: "fixed", width: "100%", zIndex: 2000 }}>
            <AlertTitle>{title}</AlertTitle>
            {content ?? ""}
        </MuiAlert>
    );
};

export default React.memo(Banner);
